import React, { useState } from 'react';

interface DeveloperWorkbenchButtonProps {
  onClick: () => void;
}

export const DeveloperWorkbenchButton: React.FC<DeveloperWorkbenchButtonProps> = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-primary-accent text-bg-deep dark:text-black flex items-center justify-center text-xl cursor-pointer shadow-lg transition-all duration-300"
      style={{
        transform: isHovered ? 'scale(1.1) rotate(15deg)' : 'scale(1) rotate(0deg)',
        boxShadow: isHovered
          ? '0 0 25px rgba(0, 221, 255, 0.6)'
          : '0 0 20px rgba(0, 221, 255, 0.3)',
      }}
      aria-label="Open Developer Workbench"
    >
      <i className="fa-solid fa-screwdriver-wrench text-base"></i>
    </button>
  );
};

export default DeveloperWorkbenchButton;
